var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"url":_vm.cards.url,"title":"لیست شباها","fields":_vm.cards.fields,"params":_vm.cards.params,"detailCallFun":_vm.cards.detailCallFun,"detailCallFunType":_vm.cards.detailCallFunType},on:{"handle_function_call":_vm.ShowDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }